export default class ContactOverview {
  constructor(el) {
    this.el = el;
    this.form = null;
    this.validated = false;
    this.currentNavItem = null;
    this.currentSection = null;
    this.currentTab = "";
    this.init();
    this.initEvents();
  }

  init() {
    this.currentTab = "email";
    var sections = this.el.querySelectorAll(".ui.tab.ui-tab-panel");
    var navItems = this.el.querySelectorAll(".c-anchor-nav__item");
    sections.forEach((sec) => {
      if (sec.dataset.tab.includes(this.currentTab)) {
        sec.classList.add("active");
        this.currentSection = sec;
      }
    });

    navItems.forEach((item) => {
      if (item.firstElementChild.dataset.tab.includes(this.currentTab)) {
        item.classList.add("active");
        this.currentNavItem = item;
      }
    });
  }

  initEvents() {
    var navItems = this.el.querySelectorAll(".c-anchor-nav__item");
    navItems.forEach((item) => {
      item.removeEventListener("click", (e) => this.showSection(item));
      item.addEventListener("click", (e) => {
        e.preventDefault();
        this.showSection(item);
      });
    });
  }

  showSection(navItem) {
    this.currentTab = navItem.firstElementChild.dataset.tab;
    this.currentNavItem.classList.remove("active");
    this.currentSection.classList.remove("active");
    var sections = this.el.querySelectorAll(".ui.tab.ui-tab-panel");

    this.currentNavItem = navItem;
    this.currentNavItem.classList.add("active");

    sections.forEach((sec) => {
      if (sec.dataset.tab.includes(this.currentTab)) {
        this.currentSection = sec;
        this.currentSection.classList.add("active");
      }
    });
  }
}
